<template>
    <div class="schoolSuite">
        <div class="header">
          <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
        </div>
        <div class="suite_list_box" :style="`height: ${windowHeight - 180}px;`">
            <div class="suite_list" v-if="dataList && dataList.length">
                <div class="suite_line_box">

                    <div class="suite_box">
                        <div class="suite_item" :key="suiteIndex" v-for="(suiteItem, suiteIndex) in dataList">
                            <img class="suite_logo_img" :src="suiteItem.logoUrl">
                            <div class="suite_title_wrap">
                                <h2>{{suiteItem.name}}</h2>
                                <div class="suite_tag">{{suiteTypeList[suiteItem.suiteType - 1] || '其他'}}</div>
                                <div class="operation_wrap">
                                </div>
                                <div class="suite-id">suiteId: {{suiteItem.suiteId}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no_stu_msg" v-else>
                <img
                    src="https://cdnfile-10043692.file.myqcloud.com/class_brand/gridClasscard/nodata/elastic-nodata2.png"
                    alt="">
                <div>暂无套件</div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackTool from '@/components/BackTool';

    import windowResize from '@/mixins/windowResize'
    import {querySchoolSuiteList} from '@/api/schoolManage';

    export default {
        name: 'schoolSuite',
        data() {
            return {
                schoolId: this.$route.query.schoolId,
                suiteTypeList: ['应用套件', '通讯录套件', '普通应用', '通讯录应用', '其他', '家校应用'],
                dataList: []
            }
        },
        components: {BackTool},
        mixins: [windowResize],

        created() {
            querySchoolSuiteList({
                schoolId: this.schoolId
            })
                .then(data => {
                    this.dataList = data;
                });
            this.getSuiteList()
        },
        methods: {}
    }
</script>

<style lang="scss" scoped>
    @import './../../styles/mixin';

    .schoolSuite {
        padding: 12px;
        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .suite_list_box {
            @include scrollBar;

            .suite_list {
                .suite_line_box {
                    overflow: hidden;

                    .suite_title {
                        height: 20px;
                        line-height: 20px;
                        margin-top: 15px;
                        margin-left: 15px;
                        padding-left: 8px;
                        border-left: 4px solid #409EFF;
                        font-weight: bold;
                    }

                    .suite_box {
                        padding-bottom: 20px;
                        overflow: hidden;

                        .suite_item {
                            @include clearfix;
                            position: relative;
                            height: 150px;
                            margin-top: 20px;
                            margin-left: 20px;
                            padding: 10px;
                            box-sizing: border-box;
                            float: left;
                            overflow: hidden;
                            border-radius: 5px;
                            box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
                            transition: all .2s linear;

                            &:hover {
                                box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
                                transform: translate3d(0, -2px, 0);
                            }

                            .suite_logo_img {
                                float: left;
                                width: 90px;
                                height: 90px;
                                margin: 20px 15px 20px 5px;
                                border-radius: 4px;
                            }

                            .suite_title_wrap {
                                float: left;
                                width: 165px;
                                height: 125px;

                                h2 {
                                    font-size: 16px;
                                    font-weight: bold;
                                    width: 100%;
                                    max-height: 42px;
                                    word-wrap: break-word;
                                    word-break: break-all;
                                    overflow: hidden;
                                }

                                .suite_tag {
                                    padding: 5px 15px;
                                    background: #e5e5e5;
                                    text-align: center;
                                    display: inline-block;
                                    line-height: 20px;
                                }

                                .operation_wrap {
                                    font-size: 16px;
                                    margin-top: 10px;

                                    span {
                                        margin-right: 5px;
                                        color: #409EFF;
                                        cursor: pointer;
                                    }
                                }
                            }

                            .build_status {
                                position: absolute;
                                top: 10px;
                                right: -20px;
                                width: 80px;
                                height: 20px;
                                font-size: 14px;
                                line-height: 20px;
                                text-align: center;
                                color: #fff;
                                background: #409eff;
                                transform: rotate(45deg);
                            }

                            .has_send {
                                background: #f56c6c;
                            }
                        }
                    }
                }
            }

            .no_stu_msg {
                text-align: center;
                font-size: 15px;
                color: #999;
                overflow: hidden;

                img {
                    display: block;
                    margin: 30px auto 0;
                }

                div {
                    height: 20px;
                    line-height: 20px;
                    margin-top: -40px;
                }
            }
        }
        .suite-id {
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/schoolManage/schoolSuite.vue